import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";

export const GetBillingPlanBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingPlanBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_PLANS_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetBillingAddonsBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingAddonsBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_ADDONS_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetBillingDomesticWalletDepositBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingDomesticWalletDepositBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_DOMESIC_WALLET_DEPOSITS_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetBillingDomesticWalletWithdrawalBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingDomesticWalletWithdrawalBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_DOMESIC_WALLET_WITHDRAWALS_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetBillingCrossBorderPaymentBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingCrossBorderPaymentBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_CBP_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetBillingPaysBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingPaysBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_PAYS_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};

export const GetBillingReceivesBIZcore = (companyId, page, limit, query, cancellable, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillingReceivesBIZcore(companyId, page, limit, query, cancellable);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLING_RECEIVES_BIZ_CORE, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(error === "REQUEST_CANCELLED" ? true : false);
  }
};
